import gql from "graphql-tag";

// Channel
const getChannel = gql`
  query GetChannel($id: String!) {
    getChannel(id: $id) {
      id
    }
  }
`;

const getChannelProfile = gql`
  query GetChannelProfile($id: String!) {
    getChannelByPublic(id: $id) {
      profile_image
      name
      licenses {
        id
        basic_id
        start
        end
        mode
        stream_rtmp_keys
        stream_rtmp_urls
        stream_embed_urls
        stream_mode
        disk
      }
    }
  }
`;

// License
const listLicensesByChannel = gql`
  query ListLicenses($channel_id: String!) {
    listLicensesByChannel(channel_id: $channel_id) {
      items {
        id
        channel_id
        start
        end
        basic_id
        mode
        disk
        stream_mode
        stream_rtmp_keys
        stream_rtmp_urls
        stream_embed_urls
        stream_playback_urls
        channel_arn
      }
      nextToken
    }
  }
`;

// EmailTemplate
const getEmailTemplate = gql`
  query GetEmailTemplate($TemplateName: String) {
    getEmailTemplate(TemplateName: $TemplateName) {
      TemplateName
      HtmlPart
      SubjectPart
      TextPart
      createdAt
    }
  }
`;

const listEmailTemplates = gql`
  query ListEmailTemplates($limit: Int, $nextToken: String) {
    listEmailTemplates(limit: $limit, nextToken: $nextToken) {
      items {
        TemplateName
        HtmlPart
        SubjectPart
        TextPart
        createdAt
      }
      nextToken
    }
  }
`;

// Log
const listLogs = gql`
  query ListLogs(
    $category: String
    $start: String
    $end: String
    $limit: Int
    $nextToken: String
  ) {
    listLogs(
      category: $category
      start: $start
      end: $end
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        user
        message
        live_id
        channel_id
        template_name
        ip
        created_at
        level
      }
      nextToken
    }
  }
`;

// Users
const listUserRolesByRole = gql`
  query ListUserRolesByRole(
    $user_role: String!
    $limit: Int
    $nextToken: String
  ) {
    listUserRolesByRole(
      user_role: $user_role
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        email
        user_role
      }
      nextToken
    }
  }
`;

// Groups
const listGroups = gql`
  query ListGroups($channel_id: String, $limit: Int, $nextToken: String) {
    listGroups(channel_id: $channel_id, limit: $limit, nextToken: $nextToken) {
      items {
        channel_id
        group_name
        id
      }
      nextToken
    }
  }
`;

// Category
const listCategories = gql`
  query ListCategories($channel_id: String, $limit: Int, $nextToken: String) {
    listCategories(
      channel_id: $channel_id
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        channel_id
        category_name
        category_info
        id
      }
      nextToken
    }
  }
`;

// Lives
const listLives = gql`
  query ListLives($channel_id: String!, $limit: Int, $nextToken: String) {
    listLives(channel_id: $channel_id, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        start_date
        managers {
          email
        }
        stream_license_id
        stream_license {
          stream_mode
          stream_embed_urls
          stream_playback_urls
          stream_rtmp_urls
          stream_rtmp_keys
        }
        state
      }
      nextToken
    }
  }
`;

// Contents
const listContents = gql`
  query ListContents($channel_id: String!, $limit: Int, $nextToken: String) {
    listContents(
      channel_id: $channel_id
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        created_at
        author
        slide
        date
        status
        view
        key
        tags
        categories
        info
        slide
        poster
        poster_upload
        who
        who_groups
        where
        where_domains
        when
        when_start
        when_end
      }
      nextToken
    }
  }
`;

const getContent = gql`
  query GetContent($id: String!) {
    getContent(id: $id) {
      id
      title
      author
      info
      channel_id
      created_at
      date
      duration
      groups_can_access
      status
      autoplay
      mute
      stream_url
      stream_mode
      stream_timelimit
      size
      view
      tags
      categories
      thumbnail
      thumbnails
      poster
      poster_upload
      slide
      slideFile {
        signedUrl
        url
      }
      mp4File {
        signedUrl
        url
      }
      key
      who
      who_groups
      where
      where_domains
      when
      when_start
      when_end
    }
  }
`;

// Collections
const listCollections = gql`
  query ListCollections($channel_id: String!, $limit: Int, $nextToken: String) {
    listCollections(
      channel_id: $channel_id
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        created_at
        header
        who
        who_groups
        where
        where_domains
        when
        when_start
        when_end
        mode_api
        channel {
          licenses {
            mode
            domain
          }
        }
      }
      nextToken
    }
  }
`;

const getCollection = gql`
  query GetCollection($id: String!) {
    getCollection(id: $id) {
      id
      title
      info
      back_img
      back_img_login
      header
      selected_contents
      selected_categories
      selected_lives
      key
      who
      who_groups
      where
      where_domains
      when
      when_start
      when_end
      channel_id
      channel {
        licenses {
          mode
          domain
        }
      }
      mode_collection
      mode_api
      show_category
      show_item_author
      show_item_date
      show_item_view
      show_item_date_format
    }
  }
`;

export {
  getChannel,
  getChannelProfile,
  listUserRolesByRole,
  listEmailTemplates,
  getEmailTemplate,
  listLicensesByChannel,
  listLogs,
  listGroups,
  listCategories,
  listLives,
  listContents,
  getContent,
  listCollections,
  getCollection
};
